(() => {
  const panel = document.getElementById('cma-added-panel');
  const root = window.Shopify?.routes?.root || '/';
  const sectionURL = `${root}cart?section_id=cma-cart-recommendations`;
  if (!customElements.get('cma-cart-recommendations')) {
    customElements.define('cma-cart-recommendations', class extends HTMLElement {
      async init() {
        this.request?.abort();
        this.request = new AbortController();
        try {
          const response = await fetch(this.dataset.url || sectionURL, { signal: this.request.signal });
          if (!response.ok) throw new Error('Recommendations unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = document.querySelector('[data-cma-recommendation-content]');
          if (!content) throw new Error('Recommendations unavailable');
          this.innerHTML = content.innerHTML;
        } catch (error) {
          if (error.name === 'AbortError') return;
          throw error;
        }
      }
    });
  }
  if (!panel) return;
  let busy = false;
  let opener;
  panel.querySelectorAll('[data-cma-close]').forEach(button => button.addEventListener('click', () => panel.close()));
  panel.addEventListener('close', () => opener?.focus());
  panel.addEventListener('click', event => { if (event.target === panel) { const r = panel.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) panel.close(); } });
  const showError = (message, form) => {
    if (panel.open) { panel.querySelector('[data-cma-status]').textContent = message; return; }
    let error = form?.querySelector('[data-cma-add-error]');
    if (!error && form) { error = document.createElement('p'); error.dataset.cmaAddError = ''; error.setAttribute('role', 'alert'); form.append(error); }
    if (error) error.textContent = message;
  };
  const add = async (body, button, form) => {
    if (busy) return;
    busy = true;
    const previousDisabled = button?.disabled;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    form?.querySelector('[data-cma-add-error]')?.remove();
    let added = false;
    try {
      const response = await fetch(panel.dataset.addUrl, { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || panel.dataset.error);
      added = true;
      if (window.location.pathname.replace(/\/$/, '') === panel.dataset.cartUrl.replace(/\/$/, '')) { window.location.reload(); return; }
      if (!panel.open) { opener = button; panel.showModal(); }
      panel.querySelector('[data-cma-status]').textContent = data.product_title || data.title || '';
      const recommendations = panel.querySelector('cma-cart-recommendations');
      recommendations.innerHTML = '';
      await recommendations.init();
      const bubbleResponse = await fetch(`${root}?section_id=cart-icon-bubble`);
      if (bubbleResponse.ok) {
        const doc = new DOMParser().parseFromString(await bubbleResponse.text(), 'text/html');
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && doc.querySelector('.shopify-section')) bubble.innerHTML = doc.querySelector('.shopify-section').innerHTML;
      }
    } catch (error) {
      showError(added ? panel.dataset.refreshError : error.message || panel.dataset.error, form);
    } finally {
      busy = false;
      if (button) { button.disabled = previousDisabled; button.removeAttribute('aria-busy'); }
    }
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !(form.getAttribute('id') || '').startsWith('CMAProduct-')) return;
    event.preventDefault();
    add(new FormData(form), event.submitter || form.querySelector('[type="submit"]'), form);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cma-add]');
    if (!button) return;
    const body = new FormData(); body.set('id', button.dataset.cmaAdd); body.set('quantity', '1');
    add(body, button, button.closest('form') || button.closest('.cma-recommendations'));
  });
})();
